{
    "periodLabel.dateToday": "d.d."
}
